import { date, object, string } from "yup"
import { ID } from "../yup.common"
const licenceModel = object({
  id: ID,
  idNumber: string().label("Licence Number"),
  issuedOn: date().label("Licence Issue Date"),
  validTill: date().label("Licence Valid Till"),
  photo: string().label("Licence Photo"),
})

export default licenceModel
